import { List, ListItem, ListItemButton, ListItemText } from "@mui/material"
import Icon from "@/components/icon/Icon"
import { RemixIconType } from "@/types/components/icon"
import { colors } from "@/components/colors"

import useRouter from "@/hooks/router/useRoute"
import { useTranslation } from "react-i18next"
import { createAccountStore } from "@/stores/account"

import "./Members.scss"
import BasicCard from "@/app/settings/overview/BasicCard"

export default function Members() {
  const router = useRouter()
  const teamProfileInfo = createAccountStore((state) => state.teamProfileInfo)

  const { t } = useTranslation("")

  const members = [
    {
      key: "players",
      icon: "team-line",
      route: { name: "players", path: "/settings/club/players" },
      count: teamProfileInfo?.playerCount || 0,
    },
    {
      key: "coaches",
      icon: "user-voice-line",
      route: { name: "coaches", path: "/settings/club/coaches" },
      count: teamProfileInfo?.coachCount || 0,
    },
  ]

  return (
    <div className="MembersCont">
      <BasicCard title={t("members")}>
        <List className="Members">
          {members.map((member) => {
            return (
              <ListItem key={member.key} className="Member">
                <ListItemButton className="Button" onClick={() => router?.push(member.route.path)}>
                  <div className="Icon">
                    <Icon
                      type={member.icon as RemixIconType}
                      size={24}
                      color={colors.neutral.grey[600]}
                    />
                  </div>
                  <ListItemText primary={t(member.key)} secondary={member.count} className="Text" />
                </ListItemButton>
              </ListItem>
            )
          })}
        </List>
      </BasicCard>
    </div>
  )
}
